import { Component, inject, signal } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../services/auth/auth.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'reset-link',
  imports: [RouterLink, SkeletonModule, ButtonModule],
  templateUrl: './reset-link.component.html',
  
})
export class ResetLinkComponent {
  isLoadingYYCLogo: boolean = true;
  isSubmitting: boolean = false;
  countdown = signal<number>(60);
  isButtonDisabled = signal<boolean>(false);
  email = signal<string>('');

  router = inject(Router);
  authService = inject(AuthService);

  /**
   * The address arrives in navigation state from `ForgotPasswordComponent`.
   * Read from `history.state` (falling back to the in-flight navigation) so it
   * survives an F5: `getCurrentNavigation()` alone is `null` on any cold load,
   * which used to bounce a refreshed page back to forgot-password. `email` is
   * narrowed to a string because `history.state` is browser-owned and may hold
   * another page's state.
   */
  getEmail() {
    const navigationState = this.router.getCurrentNavigation()?.extras?.state as
      | { email?: unknown }
      | undefined;
    const historyState = history.state as { email?: unknown } | null;
    const email = navigationState?.email ?? historyState?.email;
    if (typeof email === 'string' && email.length > 0) {
      this.email.set(email);
    } else {
      this.router.navigate(['/auth/forgot-password']);
    }
  }

  calculateCountdown() {
    this.isButtonDisabled.set(true);
    const interval = setInterval(() => {
      if (this.countdown() > 1) {
        this.countdown.set(this.countdown() - 1);
      } else {
        clearInterval(interval);
        this.countdown.set(60); 
        this.isButtonDisabled.set(false);
      }
    }, 1000);
  }

  constructor() {
    this.getEmail();
    this.calculateCountdown();
  }

  sendResetLink() {
    this.calculateCountdown();
    
    const credentials = {
      email: this.email(),
    };

    this.authService
      .forgotPassword(credentials)
      .pipe().subscribe();
  }

}
